import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import orderflowChartImg from '../../../assets/images/orderflow-chart.png';
// import diwaliOffer from '../../../assets/images/diwali_offer_ad.jpeg';
// import offer from '../../../assets/images/independence26-banner.jpeg';
import offer from '../../../assets/images/diwali26-banner.jpeg';
import './Sections.css';
import './HeroSection.css';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section" id="hero">
      <div className="container">
        <img src={offer} alt="freedom_offer" style={{width: "100%", marginLeft: 0, marginRight: 40, marginTop: -20, marginBottom: 20}} />
        {/* <motion.div 
            className="hero-image-column"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <div className="hero-image-container">
              <img 
                src={offer} 
                alt="Orderflow Chart Trading Platform" 
                loading="eager" 
                decoding="async" 
                fetchpriority="high"
              />
            </div>
          </motion.div> */}
        {/* Main Title - Top Center */}
        <motion.h1 
          className="hero-main-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          When You See What Others Don't — You Trade How Others Can't.
        </motion.h1>
        
        <div className="hero-content-wrapper">
          {/* Left Content Column */}
          <div className="hero-content-column">
            <motion.div 
              className="hero-content-card"
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <motion.h2 
                className="hero-subtitle"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                Discover institutional footprints, hidden auctions, and volume pressure — in real time.
              </motion.h2>
              
              <motion.p 
                className="hero-subtitle"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                Direct tie-up with NSE → ultra-low-latency, exchange-grade data built for speed and accuracy
              </motion.p>
              
              <motion.div 
                className="hero-cta-container"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
              >
                <button 
                  className="btn btn-primary btn-lg hero-cta-primary"
                  onClick={() => navigate('/login')}
                >
                  Start Streaming Charts Now
                </button>
                
                <button 
                  className="btn btn-outline btn-lg hero-cta-secondary"
                  onClick={() => {
                    document.getElementById('video-walkthrough').scrollIntoView({ 
                      behavior: 'smooth' 
                    });
                  }}
                >
                  Watch the 60-Second Walkthrough
                </button>
              </motion.div>
            </motion.div>
          </div>
          
          {/* Right Image Column */}
          <motion.div 
            className="hero-image-column"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <div className="video-feature-embed">
                <iframe 
                  src={`https://www.youtube.com/embed/T2skZkXhZaM`}
                  title={"Introduction to Vtrender™'s Order Flow Chart Features"}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                ></iframe>
              </div>
          </motion.div>
          {/* <motion.div 
            className="hero-image-column"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <div className="hero-image-container">
              <img src={orderflowChartImg} alt="Orderflow Chart Trading Platform" />
            </div>
          </motion.div> */}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
